import React from "react";
import { useFormikContext } from "formik";
import FormikCheckbox from "../fields/FormikCheckbox";
import {
  aiExperienceOptions,
  expectationOptions,
  getOptionLabel,
  obstacleOptions,
  occupationOptions,
  regionOptions,
} from "../data/fieldOptions";

const SummarySection = ({ number, title, children }) => (
  <li>
    <strong>{number}</strong>
    <h5>{title}</h5>
    <div>{children}</div>
  </li>
);

const SummaryValue = ({ label, children }) => (
  <p>
    <b>{label}:</b> {children || "—"}
  </p>
);

const ConfirmationStep = () => {
  const { values } = useFormikContext();

  return (
    <div className="step submit">
      <h3 className="main_question">
        <strong>4/4</strong>Confirmación
      </h3>
      <div className="summary registration-summary">
        <ul>
          <SummarySection number="1" title="Datos personales">
            <SummaryValue label="Nombre completo">{values.name}</SummaryValue>
            <SummaryValue label="Correo electrónico">{values.email}</SummaryValue>
            <SummaryValue label="Teléfono">{values.phone}</SummaryValue>
          </SummarySection>
          <SummarySection number="2" title="Perfil">
            <SummaryValue label="Región">
              {getOptionLabel(regionOptions, values.region)}
            </SummaryValue>
            <SummaryValue label="Ocupación">
              {values.occupation
                ? getOptionLabel(occupationOptions, values.occupation)
                : "No informada"}
            </SummaryValue>
            <SummaryValue label="Emprendimiento o idea">
              {values.project_name}
            </SummaryValue>
          </SummarySection>
          <SummarySection number="3" title="Diagnóstico">
            <SummaryValue label="Obstáculo actual">
              {getOptionLabel(obstacleOptions, values.obstacle)}
            </SummaryValue>
            <SummaryValue label="Uso previo de IA">
              {getOptionLabel(aiExperienceOptions, values.experience)}
            </SummaryValue>
            <SummaryValue label="Expectativa principal">
              {getOptionLabel(expectationOptions, values.expectation)}
            </SummaryValue>
          </SummarySection>
        </ul>
      </div>
      <FormikCheckbox name="legal_terms_accepted">
        Declaro haber leído las Bases Legales de la campaña “Upbirk GrowthLab2026”
        y acepto registrar mi startup utilizando datos técnicamente reales y
        coherentes para calificar. Además, autorizo el tratamiento de mis datos
        según la Ley N° 19.628. <span aria-hidden="true">*</span>
      </FormikCheckbox>
    </div>
  );
};

export default ConfirmationStep;
